import { useRef } from "react";

const gifs = [
  { poster: "/images/test3.jpg", video: "/images/gif3.mov" },
  { poster: "/images/test1.jpg", video: "/images/gif1.mov" },
  { poster: "/images/test2.jpg", video: "/images/gif2.mov" },
];

const GifShowcaseSection = () => {
  const videoRefs = useRef([]);

  const handleMouseEnter = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {}); // ignoruj przerwania
    }
  };

  const handleMouseLeave = (index) => {
    const video = videoRefs.current[index];
    if (video && !video.paused) {
      video.pause();
    }
  };

  return (
    <section className="hidden md:block bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row gap-6 justify-center items-center">
        {gifs.map((gif, index) => (
          <div
            key={index}
            className="relative w-full md:w-1/3 aspect-[2/3] overflow-hidden shadow-xl group transition-transform duration-300 hover:scale-105"
            style={{
              clipPath: "polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%)",
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave(index)}
          >
            {/* Poster */}
            <img
              src={gif.poster}
              className="absolute inset-0 h-full w-full object-cover transition-opacity duration-300 group-hover:opacity-0"
            />

            {/* Video */}
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              src={gif.video}
              className="h-full w-full object-cover"
              muted
              playsInline
              preload="auto"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default GifShowcaseSection;
